const differentiators = [
  {
    icon: 'ri-tools-line',
    title: 'Built for Home Service Businesses',
    description: 'Specifically designed for plumbers, electricians, HVAC, landscapers, painters, and contractors'
  },
  {
    icon: 'ri-brain-line',
    title: 'Modern AI Solutions',
    description: 'Cutting-edge technology that actually works and delivers measurable results'
  },
  {
    icon: 'ri-time-line',
    title: 'Saves Time & Increases Revenue',
    description: 'Automate repetitive tasks and focus on what you do best - serving customers'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Professional Systems',
    description: 'Enterprise-level automation without the complexity or big agency price tag'
  },
  {
    icon: 'ri-rocket-line',
    title: 'Competitive Advantage',
    description: 'Look more advanced and operate more efficiently than your competition'
  }
];

export default function WhyBayfront() {
  return (
    <section className="relative py-32 bg-gradient-to-b from-black via-[#0a0e27] to-black overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="lg:col-span-2 scroll-reveal">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Why Choose<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600">
                Bayfront Intelligence?
              </span>
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed mb-8">
              We're not just another tech company. We're specialists in AI automation for home service businesses, helping you modernize operations, stop losing leads, and grow faster than ever before.
            </p>
            <p className="text-lg text-gray-400 leading-relaxed">
              Our systems are built to make you look professional, save you time, and convert more leads into paying customers - all while you focus on delivering excellent service.
            </p>
          </div>

          {/* Right Differentiators */}
          <div className="lg:col-span-3 space-y-4">
            {differentiators.map((item, index) => (
              <div
                key={index}
                className="group scroll-reveal flex items-start gap-4 bg-white/[0.02] backdrop-blur-xl border border-white/10 rounded-2xl p-6 transition-all duration-500 hover:bg-white/[0.05] hover:border-cyan-400/30 hover:translate-x-2 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-xl border border-cyan-400/30 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                  <i className={`${item.icon} text-xl text-cyan-400 drop-shadow-[0_0_10px_rgba(0,212,255,0.8)]`} />
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {item.description}
                  </p>
                </div>

                {/* Arrow */}
                <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-line text-cyan-400 text-xl" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}